import React from "react";
import styled from "styled-components";

// Styled Components
const Section = styled.section`
  padding: 80px 20px;
  background-color: #f8f9fa;
  color: #111;
  text-align: center;
`;

const Title = styled.h2`
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
  letter-spacing: 2px;
`;

const Subtitle = styled.p`
  font-size: 1rem;
  color: #666;
  margin-bottom: 40px;
  font-style: italic;
`;

const BenefitContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
  margin-top: 40px;
`;

const BenefitCard = styled.div`
  background-color: #ffffff;
  padding: 40px;
  width: 300px;
  text-align: center;
  border-radius: 15px;
  box-shadow: 0 12px 20px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 16px 30px rgb(88, 199, 192);
  }
`;

const Icon = styled.div`
  font-size: 3rem;
  margin-bottom: 20px;
  color: #007bff;
`;

const BenefitTitle = styled.h3`
  font-size: 1.3rem;
  font-weight: bold;
  margin-bottom: 10px;
  color: #111;
`;

const BenefitDescription = styled.p`
  font-size: 1rem;
  color: #555;
  line-height: 1.5;
`;

const BenefitsForBusiness = () => {
  const benefits = [
    {
      icon: "🚀",
      title: "Faster Delivery Times",
      description:
        "Hyperlocal inventory ensures products reach customers in record time.",
    },
    {
      icon: "📦",
      title: "Optimized Stock Levels",
      description:
        "Say goodbye to overstocking and stockouts with precise inventory placement.",
    },
    {
      icon: "💡",
      title: "Improved Efficiency",
      description:
        "Reduce operational complexity with AI automation and intelligent workflows.",
    },
    {
      icon: "😊",
      title: "Customer Delight",
      description:
        "Quicker, reliable deliveries that improve satisfaction and loyalty.",
    },
  ];

  return (
    <Section>
      <Title>Benefits for Your Business</Title>
      <Subtitle>
        Unlock new levels of efficiency and customer satisfaction with our
        hyperlocal inventory solution.
      </Subtitle>
      <BenefitContainer>
        {benefits.map((benefit, index) => (
          <BenefitCard key={index}>
            <Icon>{benefit.icon}</Icon>
            <BenefitTitle>{benefit.title}</BenefitTitle>
            <BenefitDescription>{benefit.description}</BenefitDescription>
          </BenefitCard>
        ))}
      </BenefitContainer>
    </Section>
  );
};

export default BenefitsForBusiness;
